import { c as _c } from "react/compiler-runtime";
import { UseMutationResult } from "@tanstack/react-query";
import { Form, ProfilChip } from "@/app/(main)/(club)/mes-clubs/[id]/components/(wanted-profiles)";
interface EditorProps {
  onSubmit: (value: string) => Promise<void>;
  isPending: boolean;
  error?: Error | null;
  profils: string[];
  shakeIndex: number | null;
  removeMutation: UseMutationResult<string[], Error, string, unknown>;
  addMutation: UseMutationResult<string[], Error, string, unknown>;
}
const MAX_PROFILES = 15;
export const Editor: React.FC<EditorProps> = t0 => {
  const $ = _c(28);
  const {
    onSubmit,
    isPending,
    error,
    profils,
    removeMutation,
    shakeIndex,
    addMutation
  } = t0;
  const isMaxProfilesReached = profils.length >= MAX_PROFILES;
  let t1;
  if ($[0] !== error || $[1] !== isMaxProfilesReached || $[2] !== isPending || $[3] !== onSubmit) {
    t1 = <Form onSubmit={onSubmit} isPending={isPending} error={error} disabled={isMaxProfilesReached} />;
    $[0] = error;
    $[1] = isMaxProfilesReached;
    $[2] = isPending;
    $[3] = onSubmit;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== profils || $[6] !== removeMutation || $[7] !== shakeIndex) {
    let t3;
    if ($[9] !== removeMutation || $[10] !== shakeIndex) {
      t3 = (profil, index) => <ProfilChip key={index} profil={profil} onRemove={() => removeMutation.mutate(profil)} isRemoving={removeMutation.variables === profil} className={shakeIndex === index ? "animate-shake" : ""} />;
      $[9] = removeMutation;
      $[10] = shakeIndex;
      $[11] = t3;
    } else {
      t3 = $[11];
    }
    t2 = profils.map(t3);
    $[5] = profils;
    $[6] = removeMutation;
    $[7] = shakeIndex;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[12] !== addMutation.isPending) {
    t3 = addMutation.isPending && <div className="bg-light-grey animate-pulse h-7 w-28 [border-radius:8px]" />;
    $[12] = addMutation.isPending;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== t2 || $[15] !== t3) {
    t4 = <div className="flex flex-wrap gap-2">{t2}{t3}</div>;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] !== isMaxProfilesReached) {
    t5 = isMaxProfilesReached && <p className="text-warning2 text-sm italic">Nombre maximum de profils atteint ({MAX_PROFILES})</p>;
    $[17] = isMaxProfilesReached;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== t4 || $[20] !== t5) {
    t6 = <div className="flex flex-col gap-2">{t4}{t5}</div>;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  let t7;
  if ($[22] !== removeMutation.error) {
    t7 = removeMutation.error && <p className="text-primary text-sm">Une erreur est survenue lors de la suppression du profil. Veuillez réessayer.</p>;
    $[22] = removeMutation.error;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  let t8;
  if ($[24] !== t1 || $[25] !== t6 || $[26] !== t7) {
    t8 = <div className="flex flex-col gap-4">{t1}{t6}{t7}</div>;
    $[24] = t1;
    $[25] = t6;
    $[26] = t7;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  return t8;
};